import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsletterInterface } from '../../../core/models/newsletter';
import { environment } from '../../../../environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class ServiceNewsletterService {
  constructor(private http: HttpClient) {}

  postNewsletter(body: NewsletterInterface) {
    return this.http.post<NewsletterInterface>(`${environment.api}newsletter`, body);
  }
}
